<template>
  <g
    :id="'container'+singleSvgObj.id"
    @dblclick.prevent="switchEdit"
  >

    <g v-show="selected">
      <line
        :x1="x"
        :y1="y"
        :x2="x+width"
        :y2="y+height"
        :stroke="singleSvgObj.attributes.stroke"
        stroke-width="1.5"
        stroke-dasharray="8 8"
      />
      <line
        :x1="x+width"
        :y1="y"
        :x2="x"
        :y2="y+height"
        :stroke="singleSvgObj.attributes.stroke"
        stroke-width="1.5"
        stroke-dasharray="8 8"
      />
      <rect
        :x="x"
        :y="y"
        :width="width"
        :height="height"
        fill="none"
        :stroke="singleSvgObj.attributes.fill"
        stroke-width="1.5"
        marker-start="url(#dot)"
        marker-mid="url(#dot)"
        marker-end="url(#dot)"
      />
    </g>
    <path
      @click.self.left.ctrl.exact="select"
      @click.self.left.exact="defaultClickHandler"
      :id="singleSvgObj.id"
      :fill="'none'"
      :stroke="singleSvgObj.attributes.stroke"
      :d="singleSvgObj.attributes.d"
      :class="singleSvgObj.attributes.class"
      :stroke-linecap="singleSvgObj.attributes.strokelinecap"
      :stroke-linejoin="singleSvgObj.attributes.strokelinejoin"
      :stroke-width="singleSvgObj.attributes.strokewidth"
      :marker-end="singleSvgObj.attributes.markerend"
      :opacity="hasFilteredColor ? /**/ hasFilteredColor === singleSvgObj.attributes.stroke ? '1':'0.2'/**/:'1'"
    />
  </g>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('board')
export default {
  data () {
    return {
      editing: false,
      selected: false,
      x: -1,
      y: -1,
      width: -1,
      height: -1
    }
  },
  computed: {
    ...mapState({
      current: 'current',
      currentSheet: 'currentSheet',
      menu: 'menu'
    })
  },
  created () {
    setTimeout(() => {
      let square = document.querySelector(`#container${this.singleSvgObj.id}`).getBoundingClientRect()
      let svgBoard = document.querySelector('#svgBoard').getBoundingClientRect()

      this.x = square.x - svgBoard.x
      this.y = square.y - svgBoard.y
      this.width = square.width
      this.height = square.height
    }, 20)
  },
  props: {
    hasFilteredColor: String,
    singleSvgObj: Object
  },
  name: 'DessinSvg',
  methods: {
    select () {
      this.selected = !this.selected
      if (this.selected) {
        this.$parent.selectedSvgs.push(this.singleSvgObj.id)
      } else {
        this.$parent.selectedSvgs = this.$parent.selectedSvgs.filter(svg => svg !== this.singleSvgObj.id)
      }
    },
    switchEdit (e) {
      this.editing = !this.editing
    },
    defaultClickHandler (e) {
      if (this.menu.erasing) {
        this.clean(e)
      }
    },
    async clean (e) {
      // Check for autorizations
      if (
        this.menu.erasing &&
        e.target.id !== 'svgBoard' &&
        e.target.attributes.opacity.value === '1'
      ) {
        // console.log(e)

        // Sends the delete action to the backend
        let res = await fetch(
          `${process.env.URL_SSO_API}brainstorming/public/board/${this.current.id}/shape/${e.target.id}`,
          {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              urlparticipant: this.current.url_participant
            }
          }
        )
      }
    }

  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/board/DessinSvg.vue